import { gql } from '@apollo/client/core';

export const galleryBlockFragment = gql`
  fragment GalleryBlockFields on GalleryBlock {
    galleryTitle {
      json
    }
    description
    imagesCollection(limit: 12) {
      items {
        ... on ImageBlock {
          image {
            url
            title
          }
          altText
        }
      }
    }
  }
`;
